/* eslint-disable no-control-regex */
var EMAIL_REGEX = /^(?:[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-zA-Z0-9-]*[a-zA-Z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/;
var EMAIL_REGEX_NO_HTML_TAGS = /^((?!(&#60)|(&#62)).)*$/;
var INVALID_EMAIL = 'Please enter a valid email address';
export var emailInputValidator = function (value) {
    var trimmedValue = value.trim();
    return EMAIL_REGEX.test(trimmedValue) && EMAIL_REGEX_NO_HTML_TAGS.test(trimmedValue)
        ? undefined
        : INVALID_EMAIL;
};
//# sourceMappingURL=email.js.map